import {useEffect} from "react";

const Recaptcha = (props) => {

    const recaptchaSuccessCallback = (d) => {
        props.callback(d);
    }

    const recaptchaExpiredCallback = (d) => {
        props.callback("");
    }

    const recaptchaErrorCallback = (d) => {
        console.log("recaptcha error", d)
        props.callback("");
    }

    useEffect(() => {
        let scriptUrl = "https://www.google.com/recaptcha/api.js";
        let scriptTag = document.createElement("script");
        scriptTag.async = true;
        scriptTag.src = scriptUrl;
        scriptTag.type = "text/javascript";
        document.body.appendChild(scriptTag);

        window.recaptchaSuccessCallback = recaptchaSuccessCallback;
        window.recaptchaExpiredCallback = recaptchaExpiredCallback;
        window.recaptchaErrorCallback = recaptchaErrorCallback;
    })

    return <>
        <div
            className={"g-recaptcha"}
            data-sitekey="6LcDsiclAAAAAIQBeE-bsqedHl5EHoUJFB8oRohl"
            data-theme={"dark"}
            data-callback={"recaptchaSuccessCallback"}
            data-expired-callback={"recaptchaExpiredCallback"}
            data-error-callback={"recaptchaErrorCallback"}
        ></div>
    </>
}

export default Recaptcha;
